import React from 'react'
import {
    IconButton,
    Tooltip
} from '@material-ui/core'
import HelpIcon from '@material-ui/icons/Help'

import { buttonClickEvent } from '../../utils/Analytics'
import { goToFAQ } from '../../utils/UrlManipulation'

const FAQButton = () => (
    <Tooltip title="FAQ" aria-label="FAQ">
        <IconButton aria-label="FAQ" onClick={() => {
            buttonClickEvent("FAQ Button")
            goToFAQ()
        }}>
            <HelpIcon />
        </IconButton>
    </Tooltip>
)

export default FAQButton